import styled from 'styled-components';

export const BoldText = styled.span`
  color: ${props =>
    props.theme.colors.get(props.color, props.theme.colors.text.secondary)};
  ${props => props.theme.typography.bodyBold}
`;

export const PromoCodeContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  width: 100%;
`;

export const OfferCodeContainer = styled.div`
  display: grid;
  grid-template-columns: 3fr 2fr;
  gap: ${props => props.theme.spacing(2)};
`;

export const OfferCodeLabel = styled.h4`
  ${props => props.theme.typography.subheading2};
  color: ${props => props.theme.colors.status.successPrimary};
  margin-bottom: ${props => props.theme.spacing(2)};
  overflow-wrap: break-word;
`;
